// extracted by mini-css-extract-plugin
module.exports = {"sectionContact":"contact-module--sectionContact--aWmcl","wrapper":"contact-module--wrapper--3t7lG"};